import { getAvatar, getGravatar, getInitials } from 'App/services/AvatarService';

angular
	.module('upDirectives')
	.directive('upAvatar', [
		'avatarService',
		function (avatarService) {
			var link = function ($scope, elem, attr) {
				$scope.size = attr.size ? attr.size : 35;
				$scope.fontSize = parseInt($scope.size) / 2 + 'px';
				if (attr.round !== undefined) {
					$scope.round = true;
				}

				elem.find('img').on('error', function () {
					$scope.genericAvatar = avatarService.getGravatar($scope.user);
				});

				$scope.$watch(
					'user',
					function () {
						avatarService
							.getAvatar($scope.user, attr)
							.then(function (avatar) {
								$scope.genericAvatar = avatar;
							})
							.catch(e => console.log('avatar error', e));
					},
					true
				);
			};
			return {
				restrict: 'AE',
				scope: {
					user: '='
				},
				templateUrl: require('App/upsales/common/directives/templates/upAvatar.tpl.html?file'),
				link: link,
				replace: true
			};
		}
	])
	// Thin delegate to the standalone (App/services/AvatarService) — one implementation, one
	// profile-image cache. getAvatar is wrapped in $q.when because the standalone hands back a
	// native promise, and Angular consumers (the up-avatar template above) need the resolution to
	// land inside a digest to render.
	.factory('avatarService', [
		'$q',
		function ($q) {
			return {
				getAvatar: function (user, opts) {
					return $q.when(getAvatar(user, opts));
				},
				getGravatar: getGravatar,
				getInitials: getInitials
			};
		}
	]);
